import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Alert } from '@material-ui/lab';
import styles from './styles';

const useStyles = makeStyles(styles);

const ResendLinkAlert = ({ message, onResend }) => {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const sent = result && !result.failed;

  const resend = async () => {
    setBusy(true);
    setResult(await onResend());
    setBusy(false);
  };

  return (
    <Alert severity={sent ? 'success' : 'warning'} className={classes.root}>
      {sent ? result.text : message}
      {result?.failed && <span className={classes.error}>{result.text}</span>}
      {!sent && (
        <Button
          size="small"
          color="primary"
          disabled={busy}
          onClick={resend}
          className={classes.button}
        >
          Resend link
        </Button>
      )}
    </Alert>
  );
};

export default ResendLinkAlert;
